import React, { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { PROTOTYPE_PATHS, isAdminPath } from '../../lib/adminRoutes';
import '../../styles/admin-theme.css';

const THEME_KEY = 'mh-admin-theme';

export function readAdminTheme() {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    return saved === 'light' || saved === 'dark' ? saved : 'dark';
  } catch { return 'dark'; }
}

export function setAdminTheme(theme) {
  try { localStorage.setItem(THEME_KEY, theme); } catch { /* the choice just lasts this page view */ }
  document.documentElement.setAttribute('data-admin-theme', theme);
}

// Sits beside the router rather than in each page, and uses its own storage key:
// the learner `theme` key and `dark` class stay exactly as they were.
export default function AdminThemeScope() {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(null);
  const admin = isAdminPath(pathname);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('mh-admin', admin);
    if (admin) root.setAttribute('data-admin-theme', readAdminTheme());
    else root.removeAttribute('data-admin-theme');
  }, [admin]);

  if (!admin || !PROTOTYPE_PATHS.includes(pathname) || dismissed === pathname) return null;
  return (
    <div role="status" className="mh-admin-truth">
      <Icon name="Info" size={16} className="shrink-0 mt-0.5" aria-hidden="true" />
      <p className="flex-1"><strong>Tela de demonstração.</strong> Ainda não está ligada aos dados do sistema: o que aparece aqui é de exemplo e pode não ser salvo.</p>
      <button type="button" onClick={() => setDismissed(pathname)} className="underline underline-offset-2 shrink-0 min-h-6">Entendi</button>
    </div>
  );
}
